<template>
  <div class="SectionDateTimeSearchPanel">
    <div class="px-3 pt-2">
      <v-row>
        <v-col cols="12" sm="6">
          <v-row>
            <v-col class="max-width-text-title px-1 d-flex">
              <label class="my-auto">{{ $t("date") }} : </label>
            </v-col>
            <v-col>
              <dialog-date-picker
                :label="$t('date') + ':'"
                :initDate="initBeginDate"
                @dateResult="bDate"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row class="mt-2 mt-sm-0">
            <v-col class="max-width-text-title px-1 d-flex">
              <label class="my-auto">{{ $t("time") }} : </label>
            </v-col>
            <v-col>
              <dialog-time-picker
                :label="$t('time') + ':'"
                :initTime="initBeginTime"
                @dateResult="bTime"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12" sm="6">
          <v-row>
            <v-col class="max-width-text-title px-1 d-flex">
              <label class="my-auto">{{ $t("sectionType") }} : </label>
            </v-col>
            <v-col>
              <v-select
                hide-details
                v-model="sectionType"
                :items="sectionTypes"
                :label="$t('sectionType')"
                item-text="Name"
                item-value="Code"
                return-object
                dense
                solo
                v-on:change="changeSectionType"
                class="my-auto py-0"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="px-0 pt-4">
        <v-spacer></v-spacer>

        <v-btn class="px-6" color="primary" @click="search">{{ $t("search") }}</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
import DialogDatePicker from "../widget/DialogDatePicker.vue";
import DialogTimePicker from "../widget/DialogTimePicker.vue";
export default {
  components: { DialogDatePicker, DialogTimePicker },
  props: { accessTo: [String, Number] },
  data() {
    return {
      initBeginDate: null,
      beginDate: "",
      initBeginTime: "",
      beginTime: "",
      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    if (EosUtils.isWebKartAdmin()) {
      this.getAllSection();
    } else {
      this.getSectionWithPermissionNumber();
    }
  },

  methods: {
    bDate(date) {
      this.beginDate = date;
    },
    bTime(time) {
      this.beginTime = time;
    },
    getAllSection() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "-1" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },
    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", this.accessTo);

      this.$store
        .dispatch("sections/GetSectionsList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.search();
          }
        });
    },

    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        sectionCode: this.sectionType?.Code?.toString().trim() || "-1",
        date: this.beginDate,
        time: this.beginTime,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}

.max-width-text-title {
  max-width: 90px;
}
</style>
